<template>
  <modal :show.sync="modals.modal1" footerClasses="text-right" :largeModal="true">
    <h6 slot="header" class="modal-title text-success font-weight-bold" id="modal-title-default">
      {{ title }}
    </h6>
    <div class="d-block">
      <ValidationObserver v-slot="{ handleSubmit }" ref="formObserver">
        <form ref="form" @submit.stop.prevent="handleSubmit(submit)">
          <div class="row"></div>
          <div class="row">
            <div class="col-sm-3 mb-2">
              <ValidationProvider name="No. Permohonan" rules="required" v-slot="{ errors }">
                <base-input label="No. Permohonan" v-model="form.no_permohonan" :required="true" :error="errors[0]"
                  :valid="!errors[0]" />
              </ValidationProvider>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6 mb-2">
              <div class="form-group has-label">
                <label> Jenis Permohonan
                  <span>*</span></label>

                <ValidationProvider name="Pilih Jenis Pengurangan" rules="required" v-slot="{ errors }">
                  <select class="form-control" v-model="form.kode_pengurangan" :class="[
                      { 'is-valid': !errors[0] },
                      { 'is-invalid': errors[0] },
                    ]">
                    <option selected value="">Pilih Jenis Pengurangan</option>
                    <option :value="val.id" v-for="(val, index) in optionPengurangan" :key="index">
                      {{ val.name }}</option>
                  </select>
                  <span class="text-danger text-sm" v-show="errors[0]">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <ValidationProvider name="Alasan Pengurangan" rules="required" v-slot="{ errors }">
                <base-text-area label="Keterangan" v-model="form.keterangan" :required="true" :error="errors[0]"
                  :valid="!errors[0]"></base-text-area>
              </ValidationProvider>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 mb-2">
              <ValidationProvider name="Nilai Pengurangan" rules="required|numeric|digits:2" v-slot="{ errors }">
                <base-input label="Nilai Pengurangan" v-model="form.pengurangan" :required="true"
                  :error="errors[0]" :valid="!errors[0]" />
              </ValidationProvider>
            </div>
          </div>
          <fieldset style="padding: 5px; margin-top: 10px">
            <legend>Dokumen Pendukung</legend>

            <div class="row">
              <div class="col-sm-12 mb-2">
                <span class="text-danger text-sm">Perhatian!</span>
                <ul>
                  <li><span class="text-danger text-sm">File yang diperbolehkan untuk di upload adalah
                      pdf/jpeg/jpg/png.</span></li>
                  <li><span class="text-danger text-sm">File tidak diperbolehkan lebih dari 2Mb.</span></li>
                </ul>
                Jika file yang diupload lebih dari 2mb silahkan untuk compress file tersebut di: <a
                  href="https://www.ilovepdf.com/compress_pdf" target="_blank">Pdf Compress</a> dan <a
                  href="https://imageresizer.com/image-compressor" target="_blank">Image Compress</a>

              </div>
            </div>
            <div class="row">
              <div class="table-responsive-sm col-md-12">
                <table class="table b-table table-hover table-bordered table-sm">
                  <thead>
                    <tr class="tr-values vs-table--tr tr-table-state-null">
                      <th>Nama Dokumen</th>
                      <th>File</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[1].includes(form.kode_pengurangan)">
                      <td>Surat Keterangan dari Dinas Sosial</td>
                      <td id="sk_dinas_sosial">
                        <div v-if="form.sk_dinas_sosial">
                          <button color="success" @click="downloadFile('sk_dinas_sosial')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('sk_dinas_sosial')"
                            type="border" size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'sk_dinas_sosial')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[1].includes(form.kode_pengurangan)">
                      <td>Kartu Penerimaan Manfaat (PKH)</td>
                      <td id="pkh">
                        <div v-if="form.pkh">
                          <button color="success" @click="downloadFile('pkh')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('pkh')" type="border"
                            size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'pkh')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[2, 13].includes(form.kode_pengurangan)">
                      <td>Foto Lokasi dan titik koordinat</td>
                      <td id="foto">
                        <div v-if="form.foto">
                          <button color="success" @click="downloadFile('foto')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('foto')" type="border"
                            size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'foto')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[3].includes(form.kode_pengurangan)">
                      <td>Surat Penegasan Persetujuan Penyediaan Kredit (SP3K) Bank atau Sejenis</td>
                      <td id="sp3k">
                        <div v-if="form.sp3k">
                          <button color="success" @click="downloadFile('sp3k')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('sp3k')" type="border"
                            size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'sp3k')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[3].includes(form.kode_pengurangan)">
                      <td>Surat Pernyataan Permohonan KPR bersubsidi </td>
                      <td id="sp_permohonan_kpr">
                        <div v-if="form.sp_permohonan_kpr">
                          <button color="success" @click="downloadFile('sp_permohonan_kpr')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('sp_permohonan_kpr')"
                            type="border" size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'sp_permohonan_kpr')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[4, 5].includes(form.kode_pengurangan)">
                      <td>Surat Keterangan Hibah </td>
                      <td id="sk_hibah">
                        <div v-if="form.sk_hibah">
                          <button color="success" @click="downloadFile('sk_hibah')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('sk_hibah')" type="border"
                            size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'sk_hibah')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[4, 5].includes(form.kode_pengurangan)">
                      <td>Scan Kartu Keluarga Masing-Masing Pihak </td>
                      <td id="kk">
                        <div v-if="form.kk">
                          <button color="success" @click="downloadFile('kk')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('kk')" type="border"
                            size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'kk')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[6].includes(form.kode_pengurangan)">
                      <td>Surat Keterangan / Sertifikat yang dibeli Pemerintah </td>
                      <td id="sk_sertifikat">
                        <div v-if="form.sk_sertifikat">
                          <button color="success" @click="downloadFile('sk_sertifikat')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('sk_sertifikat')"
                            type="border" size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'sk_sertifikat')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[6, 7].includes(form.kode_pengurangan)">
                      <td>Surat Kesepakatan Ganti Rugi </td>
                      <td id="sk_ganti_rugi">
                        <div v-if="form.sk_ganti_rugi">
                          <button color="success" @click="downloadFile('sk_ganti_rugi')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('sk_ganti_rugi')"
                            type="border" size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'sk_ganti_rugi')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[8].includes(form.kode_pengurangan)">
                      <td>Laporan Keuangan </td>
                      <td id="laporan_keuangan">
                        <div v-if="form.laporan_keuangan">
                          <button color="success" @click="downloadFile('laporan_keuangan')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('laporan_keuangan')"
                            type="border" size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'laporan_keuangan')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[8].includes(form.kode_pengurangan)">
                      <td>Surat Persetujuan Rekonstruksi Utang Usaha </td>
                      <td id="surat_persetujuan">
                        <div v-if="form.surat_persetujuan">
                          <button color="success" @click="downloadFile('surat_persetujuan')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('surat_persetujuan')"
                            type="border" size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'surat_persetujuan')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[9].includes(form.kode_pengurangan)">
                      <td>Akta Penggabungan Usaha / Akta Notaris Penggabungan </td>
                      <td id="akta">
                        <div v-if="form.akta">
                          <button color="success" @click="downloadFile('akta')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('akta')" type="border"
                            size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'akta')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[9].includes(form.kode_pengurangan)">
                      <td>Surat Persetujuan penggunaan nilai buku dari pejabat notaris </td>
                      <td id="sk_persetujuan">
                        <div v-if="form.sk_persetujuan">
                          <button color="success" @click="downloadFile('sk_persetujuan')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('sk_persetujuan')"
                            type="border" size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'sk_persetujuan')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[11].includes(form.kode_pengurangan)">
                      <td>SK Pensiun </td>
                      <td id="sk_pensiun">
                        <div v-if="form.sk_pensiun">
                          <button color="success" @click="downloadFile('sk_pensiun')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('sk_pensiun')" type="border"
                            size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'sk_pensiun')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[11].includes(form.kode_pengurangan)">
                      <td>Surat Keterangan tidak mampu secara ekonomi (Desa/Lurah) </td>
                      <td id="sk_tidak_mampu">
                        <div v-if="form.sk_tidak_mampu">
                          <button color="success" @click="downloadFile('sk_tidak_mampu')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('sk_tidak_mampu')"
                            type="border" size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'sk_tidak_mampu')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null" v-if="[12].includes(form.kode_pengurangan)">
                      <td>Dokumen/Surat Ijin/Bukti terdaftar sebagai badan usaha </td>
                      <td id="dokumen_ijin_usaha">
                        <div v-if="form.dokumen_ijin_usaha">
                          <button color="success" @click="downloadFile('dokumen_ijin_usaha')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('dokumen_ijin_usaha')"
                            type="border" size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'dokumen_ijin_usaha')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null"
                      v-if="[12, 13].includes(form.kode_pengurangan)">
                      <td>Foto Lokasi </td>
                      <td id="foto">
                        <div v-if="form.foto">
                          <button color="success" @click="downloadFile('foto')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('foto')" type="border"
                            size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'foto')" />
                      </td>
                    </tr>
                    <tr class="tr-values vs-table--tr tr-table-state-null"
                      v-if="[12, 13].includes(form.kode_pengurangan)">
                      <td>Foto Bangunan </td>
                      <td id="foto_bangunan">
                        <div v-if="form.foto_bangunan">
                          <button color="success" @click="downloadFile('foto_bangunan')" type="border" size="small">
                            Download File
                          </button>
                          <button style="margin-left: 5px" color="danger" @click="deleteFile('foto_bangunan')"
                            type="border" size="small">
                            Hapus File
                          </button>
                        </div>
                        <input v-else type="file" @change="uploadFiles($event, 'foto_bangunan')" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </fieldset>
          <br />
          <!-- / PAGE CONTENT ENDS -->
          <div class="row float-right">
            <div class="col-md-12 col-sm-12">
              <template v-if="isBusy">
                <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                <strong>Loading...</strong>
              </template>
              <base-button v-else type="success" nativeType="submit" icon="ni ni-send">{{ edit ? "Update" : "Simpan"
              }}</base-button>
              <base-button type="warning" @click="modals.modal1 = false">Tutup</base-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Swal from "sweetalert2";
import axios from "axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { Money } from "v-money";

export default {
  components: {
    Modal,
    PulseLoader,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    Money,
  },
  props: {
    title: {
      type: String,
      description: "Judul Modal",
    },
    code: {
      type: String,
      description: "Code Pajak",
    },
    url: {
      type: String,
      description: "Url Pajak",
    },
  },
  data() {
    return {
      edit: false,
      modals: {
        modal1: false,
      },
      isBusy: false,
      optionPengurangan: [
        {
          id: 1,
          name: 'PSTL Tidak Mampu'
        },
        {
          id: 2,
          name: 'Hak Pengelolaan Lahan'
        },
        {
          id: 3,
          name: 'Perumahan'
        },
        {
          id: 4,
          name: 'Hibah Orang Pribadi'
        },
        {
          id: 5,
          name: 'Waris dan Hibah Wasiat'
        },
        {
          id: 6,
          name: 'Ganti Rugi Pemerintah di bawah NJOP'
        },
        {
          id: 7,
          name: 'Pengganti atas tanah dibebaskan pemerintah'
        },
        {
          id: 8,
          name: 'Badan terkena dampak krisis ekonomi'
        },
        {
          id: 9,
          name: 'Badan yang melakukan merger Usaha (konsolidasi)'
        },
        {
          id: 10,
          name: 'Tanah/Bangunan tidak berfungsi karena terdampak bencana alam'
        },
        {
          id: 11,
          name: 'Veteran, Pensiun PNS, Pernawirawan TNI, POLRI atau Janda/Duda'
        },
        {
          id: 12,
          name: 'KOPRI yang memperoleh perumahan KOPRI/PNS'
        },
        {
          id: 13,
          name: 'Badan yang memperoleh Sertifikat untuk UKM'
        }
      ],
      form: {
        no_permohonan: null,
        keterangan: null,
        kode_pengurangan: 0,
        foto_bangunan: null,
        foto: null,
        dokumen_ijin_usaha: null,
        sk_tidak_mampu: null,
        sk_pensiun: null,
        sk_persetujuan: null,
        akta: null,
        laporan_keuangan: null,
        surat_persetujuan: null,
        sk_ganti_rugi: null,
        sk_sertifikat: null,
        kk: null,
        sk_hibah: null,
        sp_permohonan_kpr: null,
        sp3k: null,
        pkh: null,
        sk_dinas_sosial: null,
        pengurangan: 0,
      },
    };
  },
  methods: {
    hideModal() {
      this.modals.modal1 = false;
    },
    async submit() {
      const vm = this;
      this.$refs.formObserver.validate().then(async (result) => {
        if (result) {
          try {
            this.isBusy = true;
            let { status } = vm.item
              ? await axios.post("/api/bphtb/pengurangan/update", {
                data: vm.form,
                id: vm.item.id,
              })
              : await axios.post("/api/bphtb/pengurangan/create", vm.form);
            if (status >= 200 && status <= 202) {
              Swal.fire({
                title: "",
                text: vm.edit
                  ? "Update data berhasil."
                  : "Permohonan Pengurangan Pajak BPHTB Berhasil, Terima kasih sudah mendata pajak Anda. Pajak Anda membantu untuk memajukan Kabupaten Ketapang. Terima kasih",
                icon: "success",
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Tutup!",
              }).then(() => {
                this.$emit("resetTable");
                vm.hideModal();
              });
            }
          } catch (error) {
          } finally {
            this.isBusy = false;
          }
        } else {
          this.$vs.notify({
            title: "Error",
            text: "Periksa Input Anda",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
        }
      });
    },
    async uploadFiles(event, name) {
      const files = event.target.files;
      const file = new FormData();
      file.append("file", files[0]);
      let fileName = files[0]["name"];
      file.append(
        "filename",
        name + "." + fileName.substr(fileName.lastIndexOf(".") + 1)
      );
      if (files[0]["size"] > 1024 * 1024 * 2) {
        alert("File terlalu besar harus kurang dari 2MB (> 2MB)");
        return;
      }
      if (
        files[0]["type"] != "image/png" &&
        files[0]["type"] != "image/jpeg" &&
        files[0]["type"] != "application/pdf"
      ) {
        alert("File yang Anda upload bukan PDF/Image");
        return;
      }
      try {
        let { data } = await axios.post("/api/v1/upload", file);
        this.form[name] = data;
      } catch (error) {
        // console.log(error);
        this.form[name] = null;
      } finally {
      }
    },
    downloadFile(name) {
      axios({
        url: "/api/v1/download_pdf?filename=" + this.form[name], //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", this.form[name]); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
    deleteFile(name) {
      this.form[name] = null;
    },
    showModal() {
      const me = this;
      this.modals.modal1 = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 80% !important;
  margin: 1.75rem auto;
}

.has-success:after,
.has-danger:after {
  width: 19px;
  height: 19px;
  line-height: 19px;
  text-align: center;
  font-family: "NucleoIcons";
  display: inline-block;
  position: absolute;
  right: 15px;
  top: 29px;
  -webkit-transform: translateY(50%);
  transform: translateY(50%);
  border-radius: 50%;
  font-size: 9px;
  opacity: 1;
}
</style>